var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export default function Vector() {
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "55", height: "54", viewBox: "0 0 55 54", fill: "none" }, { children: _jsx("path", { d: "M27.4985 0L29.4677 11.0494C30.7363 18.179 36.3199 23.7593 43.45 25.0309L54.5 27L43.45 28.9691C36.3199 30.2407 30.7394 35.821 29.4677 42.9506L27.4985 54L25.5292 42.9506C24.2606 35.821 18.677 30.2407 11.55 28.9691L0.5 26.9969L11.55 25.0278C18.6801 23.7562 24.2606 18.1759 25.5292 11.0463L27.4985 0Z", fill: "#C9FAEC" }) })));
}
